import React from "react";
import { Link } from "react-router-dom";
import { AWS_URL } from "./config/constants";

const SupportHeader = (props) => {
  const width = window.innerWidth;
  const isMobile = width <= 512;

  return (
    <div
      className="support-header"
      style={{
        backgroundImage: `url(${AWS_URL}logo/support.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className={`${
          isMobile ? "fix-header-support" : ""
        } nav-top back-transparent`}
      >
        <Link
          to="/"
          className="back-transparent"
          style={{ paddingLeft: isMobile ? "0px" : "24px", gap: "7.24px" }}
        >
          <img
            className="logo-red-circle"
            src={`${AWS_URL}logo/logoRedCircle.png`}
            alt=""
          />
          <img
            className="logo-red-circle"
            src={`${AWS_URL}logo/RedCircleRed.png`}
            alt=""
          />
        </Link>
        <Link
          className={`${
            isMobile ? "w50 f-16 back-transparent" : "f-18 back-transparent"
          }`}
          to="/"
          style={{ marginLeft: "auto" }}
        >
          <span className="d-inline-block ls-3 fw-400 text-white responsive-font-18-16 back-transparent">
            Go back to Feeds
          </span>
        </Link>
      </div>
      <div className="nav-center text-white back-transparent">
        {props.title}
      </div>
      <div className="support-header__subtitle">
        We're here to help. Create a ticket and we'll respond shortly.
      </div>
    </div>
  );
};

export default SupportHeader;
